import { jsx as _jsx } from "react/jsx-runtime";
import { BlankPage } from '../../Components/Layout/Page';
import useQueryParameters from '../../Hooks/UseQueryParameters';
import { useState } from 'react';
import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useOrganisationService } from '../../Services/OrganisationService';
import { getOrganisationLink, HomeShowOrgChooserQueryParam } from '../../Utils/NavigationUtils';
import { GlobalRoutes } from '../../Utils/NavigationUtils';
import LoadingSpinner from '@cb/solaris-react/Components/Loading/LoadingSpinner';
export default function HomePage(props) {
    const queryParams = useQueryParameters();
    const showOrgChooser = queryParams.get(HomeShowOrgChooserQueryParam) === 'true';
    const [organisationId, setOrganisationId] = useState();
    const [loading, setLoading] = useState(!showOrgChooser);
    const organisationService = useOrganisationService();
    useEffect(() => {
        if (!showOrgChooser) {
            organisationService
                .getOrganisationIdFromLocalStorage()
                .then((orgId) => {
                setOrganisationId(orgId);
                setLoading(false);
            })
                .catch((err) => {
                throw err;
            });
        }
    }, [showOrgChooser, organisationService]);
    if (loading) {
        return (_jsx(BlankPage, { pageTitle: props.pageTitle, children: _jsx(LoadingSpinner, { overlay: true, text: 'Loading current organisation' }) }));
    }
    if (organisationId) {
        return _jsx(Redirect, { to: getOrganisationLink(organisationId, '') });
    }
    return _jsx(Redirect, { to: GlobalRoutes.Organisations });
}
//# sourceMappingURL=HomePage.js.map